import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";

const getBranchCompanyGain = async (branchId) => {
  const db = getFirestore();
  const pricesCollection = collection(db, "companyGain");
  const q = query(pricesCollection, where("branchId", "==", branchId));

  try {
    const querySnapshot = await getDocs(q);
    if (!querySnapshot.empty) {
      const pricesData = querySnapshot.docs[0].data();
      
      // Check if the document has meaningful data (not just branchId)
      const hasData = pricesData.card_distribute_gain !== undefined || 
                     pricesData.water_distribute_gain !== undefined ||
                     pricesData.wifi_distribute_gain !== undefined ||
                     pricesData.card_price !== undefined ||
                     pricesData.asbeza_profit !== undefined;
      
      if (!hasData) {
        throw new Error("No prices data found for the given branchId");
      }
      
      return pricesData;
    } else {
      throw new Error("No prices data found for the given branchId");
    }
  } catch (error) {
    console.error("Error fetching branch prices:", error);
    throw error;
  }
};

export default getBranchCompanyGain;
